export const CourtOrdered = Object.freeze({
    "Med": 1,
    "MedDenVis": 2,
    "MedDen": 3,
    "MedVis": 4,
    "DenVis": 5,
    "Vis": 6,
    "Den": 7    
})